import React from 'react'
import styled, { css } from 'styled-components'
import { Box } from 'grommet'
import { device } from '../../theme/device'
import { useHideInput } from '../../contextHook/hideInput'

const HidingStyle = css`
  /* left: 100%; */
  max-width: 0;
  opacity: 0;
  visibility: hidden;
  /* overflow: hidden; */
  padding: 0;
  /* border: 0; */
  transform: translateX(130px);
  transition: transform 0.5s, opacity 0.5s, max-width 0.5s, padding 0.8s;

  /* width 5s cubic-bezier(0, 0.25, 0.5, 1); */
`

const StyledInputBox = styled(Box)`
  max-height: 58.6rem;
  padding: ${props => (!props.isRTG ? '0 2.8rem' : '0rem')};
  margin: ${props => (!props.isRTG ? '0.7rem 0' : '0.7rem 1rem')};
  opacity: 1;
  transition: transform 0.5s, opacity 0.5s, max-width 0.5s;
  visibility: visible;
  /* transition: padding 0.5s; */
  ${props => props.hiding && HidingStyle}
  @media ${device.medium} {
    transition: none !important;
    padding: ${props => (!props.isRTG ? '0 1rem' : '0rem')};
    margin: ${props => (!props.isRTG ? '3rem 0 0' : '1rem 0 0')};
  }
`

const InputBox = props => {
  const { hiding } = useHideInput()
  return <StyledInputBox {...props} hiding={hiding || props.fullScreenActive} />
}

export default InputBox
